import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Check } from 'lucide-react'
import { useAuth } from '../hooks/authContext'
import { Button } from '../components/ui/Button'
import { Input } from '../components/ui/Input'
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card'

const benefits = [
  'Tampilkan produk dalam satu link',
  'Mudah dibagikan ke WhatsApp',
  'Kelola produk kapan saja',
  'Profil usaha terlihat lebih profesional',
  'Gratis untuk memulai',
]

export default function Register() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [referral, setReferral] = useState('')
  const { register } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      const cleanReferral = referral.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
      await register(name, email, password, cleanReferral || undefined)
      navigate('/register-success')
    } catch (error) {
      // Error handled in hook
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-gray-50">
      <div className="w-full max-w-5xl grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        {/* Benefits Panel */}
        <div className="hidden lg:block">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 leading-tight">
            Daftar untuk Membuat Katalog Usaha Anda
          </h1>
          <ul className="space-y-4">
            {benefits.map((benefit, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-indigo-600" />
                </div>
                <span className="text-gray-700 text-base">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Form */}
        <Card className="w-full">
          <CardHeader className="text-center">
            <div className="lg:hidden mb-4">
              <h1 className="text-2xl font-bold text-gray-900 mb-4">
                Daftar untuk Membuat Katalog Usaha Anda
              </h1>
              <ul className="space-y-2 text-left">
                {benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                    <Check className="w-4 h-4 text-indigo-600 flex-shrink-0" />
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
            <CardTitle>Mulai Sekarang</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Name
                </label>
                <Input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Password
                </label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Kode Referral (opsional)
                </label>
                <Input
                  type="text"
                  value={referral}
                  onChange={(e) => setReferral(e.target.value.toUpperCase())}
                  placeholder="Masukkan kode referral teman"
                  autoComplete="off"
                />
                <p className="mt-1 text-xs text-gray-500">
                  Masukkan kode jika Anda mendapatkannya dari teman atau komunitas
                </p>
              </div>
              <Button type="submit" className="w-full">
                Daftar Gratis
              </Button>
              <p className="text-center text-xs text-gray-500">
                Tanpa biaya tersembunyi • Bisa digunakan langsung setelah daftar
              </p>
            </form>
            <p className="mt-4 text-center text-sm text-gray-600">
              Sudah punya akun?{' '}
              <Link to="/login" className="text-blue-600 hover:text-blue-800">
                Masuk di sini untuk mengelola katalog Anda
              </Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
